/**
 * LocalStorage設定関数
 * 基本的に永続のLocalStorageにデータを保存
 * @function setCookie
 * @param {String} key キー名
 * @param {String} value 値
 * @param {String} type 型　string/array
 * @return {Void}
 * Use
import setLocalStorage from './functions/_localStorage-setLocalStorage.js' // LocalStorageに保存
// setLocalStorage('hogeText', 'hoge', 'string') // LocalStorageに保存
// setLocalStorage('hogeArray', ['hoge','fuga'], 'array') // LocalStorageに保存
 */
const setLocalStorage = (key, value, type = 'string') => {
  if (type === 'string') {
    value = value ? value : '' // 文字列を補正
    localStorage.setItem(key, value) // localStorageにデータを保存
    return
  }
  if (type === 'array') {
    value = JSON.stringify(value) // 配列をJSONに変換
    localStorage.setItem(key, value) // localStorageにデータを保存
    return
  }
}

export default setLocalStorage
